import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Custom hook to set document title
 * @param {string} title - The title to set (can be a translation key or plain text)
 * @param {string} defaultTitle - Optional default title if translation fails
 * @param {string} suffix - Optional suffix to append (e.g., " - App Name")
 */
const useDocumentTitle = (title, defaultTitle = null, suffix = '') => {
  const { t } = useTranslation();

  useEffect(() => {
    let finalTitle = title;
    
    // Try to translate if it looks like a translation key or use as-is
    try {
      const translated = t(title, { defaultValue: title });
      finalTitle = translated !== title ? translated : (defaultTitle || title);
    } catch (error) {
      finalTitle = defaultTitle || title;
    }
    
    document.title = suffix ? `${finalTitle}${suffix}` : finalTitle;
    
    // Cleanup: reset to default on unmount (optional)
    return () => {
      // Optionally reset to a default title
    };
  }, [title, defaultTitle, suffix, t]);
};

export default useDocumentTitle;






















